export default __webpack_public_path__ + "static/media/TaraSmith.122797b5.png";